export default __webpack_public_path__ + "static/media/create_post_help.e0517eb3.jpg";